import { render, staticRenderFns } from "./PricingTariffsFeatures.vue?vue&type=template&id=c27dffa6"
import script from "./PricingTariffsFeatures.vue?vue&type=script&lang=js"
export * from "./PricingTariffsFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports